import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import getLookUpData from 'src/redux/look-up/api';
import type { InitialLookUpStateType } from 'src/redux/look-up/types';

const extraReducers = (builder: ActionReducerMapBuilder<InitialLookUpStateType>) => {
  builder.addCase(getLookUpData().pending, (state: InitialLookUpStateType) => {
    state.isFetchingLookUpOptions = true;
    // A fresh fetch is in flight; clear any error from a prior attempt so a retry reads clean.
    state.hasLookUpError = false;
  });
  builder.addCase(getLookUpData().fulfilled, (state: InitialLookUpStateType) => {
    state.isFetchingLookUpOptions = false;
  });
  builder.addCase(getLookUpData().rejected, (state: InitialLookUpStateType) => {
    state.isFetchingLookUpOptions = false;
    // Record the failure so consumers can render an error/retry affordance instead of an
    // indistinguishable empty result.
    state.hasLookUpError = true;
  });
};

export default extraReducers;
